import { DuplicateId } from "@mcleod/dispatch";
import { AutogenLayoutSalesStatus } from "./autogen/AutogenLayoutSalesStatus";

export class SalesStatus extends AutogenLayoutSalesStatus {
    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, {
            tableName: "sales_status",
            screenName: this.titleSingular,
            navigateToUrl: `${this.layoutName}?mode=update&key=`
        });
    }
}